import React from 'react';
import Navbar from '../components/navigation/Navbar/Navbar';

const AdminPageLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div className="min-h-screen">
            <div className="fixed top-0 left-0 right-0 z-50">
                <Navbar activeItem="/users" />
            </div>
            <div className="pt-[84px]">
                {children}
            </div>
        </div>
    );
};
export default AdminPageLayout;